module.exports = __webpack_public_path__ + "static/media/insights.92b341ed.svg";